export default class TaskProperties {

    public taskTypeId?              : ID
    public title                    : string
    public projectId?               : ID  // required for status selector and action required selector
    public statusId?                : ID
    public actionRequiredUserId?    : ID
    public messageId?               : ID

    constructor(rawData:any) {
        // not saved and retrieved from separate list of tasks
        this.taskTypeId             = _.get(rawData, 'taskTypeId', undefined)
        this.title                  = _.get(rawData, 'title', '')
        this.projectId              = _.get(rawData, 'projectId', undefined) // required for status selector and action required selector
        this.statusId               = _.get(rawData, 'statusId', undefined)
        this.actionRequiredUserId   = _.get(rawData, 'actionRequiredUserId', undefined)
        this.messageId              = _.get(rawData, 'messageId', undefined)
    }

    isCompleted = ()=> {
        const status = gd.session.statuses.get(this.statusId);
        if (!status) console.warn("TaskInfo isCompleted: status not found", this.statusId);
        return status ? gd.const.systemStatus.isClosed(status.systemStatus) : false;
    }

    getName = () => this.title
    setName(value:string) {this.title = value} // should also make api call to change value
    setStatus(value: ID) {this.statusId = value} // should also make api call to change value

    toJSON() {
        return {}
    }
}
